import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import * as CryptoJS from 'crypto-js';
import { Observable, Subject, takeUntil, throwError } from 'rxjs';
import { AgentList } from 'src/app/types/index.js';
import jsonConfig from 'src/assets/app-config.json';
import { $b } from '../../../libs/browser_utils.js';
import { AppdataService } from '../app-data/appdata.service';

@Injectable({
  providedIn: 'root'
})
export class MessengerService {
  // create a private subject
  private agentMessage = new Subject<any>();
  private appMessage = new Subject<any>();
  private downloadURL = new Subject<any>();
  private uiInteractions = new Subject<any>();
  private handleusers = new Subject<any>();
  private handleuserleft = new Subject<any>();
  private progressBarStatus = new Subject<any>();
  private datePicker = new Subject<any>();
  private livechatStatus = new Subject<any>();
  private agentTyping = new Subject<any>();
  private eventTransfer = new Subject<any>();
  public replyToBot = new Subject<any>();

  public appConfig;
  private chatBotDetails = {
    activeNode: {}
  }; 
  encryptKey = 'ThisIsTheSecret';

  agentList: Array<AgentList> = [];
  public LivechatStatus: any;
  public conversationApiUrl: any = '';
  public conversationLimit: number;
  public notificationURL: string;
  private VAPID_PUBLIC_KEY: string;

  // expose an Observable
  agentMessageObservable: Observable<any> = this.agentMessage.asObservable(); // For Agent Message
  appMessageObservable: Observable<any> = this.appMessage.asObservable(); // For App Message
  donwloadURLObservable: Observable<any> = this.downloadURL.asObservable();
  uiInteractionsObservable: Observable<any> = this.uiInteractions.asObservable();
  handleUserObservable: Observable<any> = this.handleusers.asObservable();
  handleUserLeftObservable: Observable<any> = this.handleuserleft.asObservable();
  handleProgressBarObservable: Observable<any> = this.progressBarStatus.asObservable();
  datePickerObservable: Observable<any> = this.datePicker.asObservable(); // For Agent Message
  livechatStatusObservable: Observable<any> = this.livechatStatus.asObservable();
  agentTypingObservable: Observable<any> = this.agentTyping.asObservable();
  eventTransferObservable: Observable<any> = this.eventTransfer.asObservable();
  replyToBotObservable: Observable<any> = this.replyToBot.asObservable();

  constructor(private http: HttpClient, private swPush: SwPush,appDataService: AppdataService) {
    
    console.log('%c MessengerService', 'color:white; background: blue;');
    console.log(this.agentList);
    

    // if (Object.keys(this.appConfig).length === 0 && this.appConfig.constructor === Object) {
    //   this.decryptAppConfig();
    // }
    appDataService.appConfigSub.subscribe((config) => {
      if (!config) {
        return;
      }
      this.appConfig = config;
      this.conversationLimit = this.appConfig.ConversationService.limit;
      this.notificationURL = this.appConfig.PushNotification.notificationURL;
      this.VAPID_PUBLIC_KEY = this.appConfig.PushNotification.vapidKey;
    });
    
  }

  private newReplySub: Subject<any>;

  get activeReplySub() {
    if (this.newReplySub) {
      this.newReplySub.next(null);
      this.newReplySub.complete();
    }
    this.newReplySub = new Subject();
    return this.replyToBot.pipe(takeUntil(this.newReplySub));
  }

  public getConversationDetails(limit) {
    const conversationID = $b.GetSessionStorage('conversationID');
    const conversationLimitCounter = this.conversationLimit + limit;
    // this.conversationApiUrl = `${
    //   this.appConfig.ConversationService.apiUrl
    // }user-conversations-timeline/${conversationID}?fromTime=0&toTime=${Date.now()}&limit=${conversationLimitCounter}`;
    this.conversationApiUrl = `${this.appConfig.ConversationService.apiUrl}user-conversations-timeline/96975347?fromTime=0&toTime=${Date.now()}&limit=${conversationLimitCounter}`;
    console.log('Conversation API Url: ', this.conversationApiUrl);
    return this.http.get(this.conversationApiUrl);
  }

  chatEventTransfer = (data) => {
    this.eventTransfer.next(data);
  };

  userChanged(data) {
    this.uiInteractions.next({ type: 'UserChange', data });
  }

  requestUserSignature() {
    this.uiInteractions.next({ type: 'RequestSign' });
  }

  // to update the initial data
  agentMessageReceived({ message, by }) {
    if (message) {
      this.agentMessage.next({ message, by });
    }
  }

  appMessageReceived(data) {
    if (data) {
      this.appMessage.next(data);
    }
  }

  passDownloadURL(data) {
    if (data) {
      this.downloadURL.next(data);
    }
  }

  handleConferenceUsers(data) {
    this.handleusers.next(data);
  }

  handleProgressBar(data) {
    this.progressBarStatus.next(data);
  }

  handleConnectedUserLeft = (data) => {
    if (data) {
      this.handleuserleft.next(data);
    }
  };

  sendDatePickerInfo(data) {
    this.datePicker.next(data);
  }

  sendLivechatStatus(data) {
    if (data) {
      this.livechatStatus.next(data);
    }
  }

  sendAgentTypingStatus = (data) => {
    if (data) {
      this.agentTyping.next(data);
    }
  };

  subscribeToNotification() {
    if ('serviceWorker' in navigator) {
      this.swPush
        .requestSubscription({
          serverPublicKey: this.VAPID_PUBLIC_KEY
        })
        .then((sub) => this.sendToServer(sub))
        .catch((err) => console.error('Could not subscribe to notifications', err));
    }
  }

  sendToServer(params: any) {
    this.http.post(this.notificationURL, { notification: params }).subscribe();
  }

  handlError(error) {
    return throwError(error.error.message);
  }

  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }


  getActiveNode() {
    return this.chatBotDetails.activeNode;
  }

  setActiveNode(activeNode) {
    this.chatBotDetails.activeNode = activeNode;
  }
}
